import classNames from 'classnames';
import { Button } from '../../../ui';
import Link from 'next/link';

const GeoCoverage = () => {
  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white relative">
      <img src="/images/worldCup/geo-bg.png" alt="Background" className="absolute z-10 w-full h-full object-cover md:object-left-top object-left" />

      <div className="container flex flex-col items-center gap-[32px] py-[48px] relative z-20">
        <div className="flex flex-col items-center gap-[18px]">
          <p className="md:text-[18px] text-[14px] text-[#000000] leading-[22px] font-thin">Our reach</p>
          <h2 className="text-center font-[500] text-[32px] md:text-[48px] leading-[39px] md:leading-[59px] text-[#000000]">GEO coverage</h2>
          <div className="md:text-[18px] text-[14px] leading-[22px] text-[#000000] text-center max-w-[518px]">
            Multi-region campaign availability across high-conversion global markets
          </div>
        </div>
        <div className="flex flex-row flex-wrap items-center justify-between w-full space-y-[16px]">
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] mt-[16px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">Europe</span>
          </div>
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">CIS</span>
          </div>
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">Asia</span>
          </div>
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">Africa</span>
          </div>
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)] transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">LATAM</span>
          </div>
          <div className="flex flex-row items-center gap-[16px] py-[10px] px-[26px] bg-white border-[1px] border-[#898989] rounded-full hover:scale-[1.05] hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]  transition-transform duration-200">
            <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.9618 0L9.47598 12.5109L3.77274 6.42455L0 9.95981L9.21387 19.7926L26.468 3.80061L22.9618 0Z" fill="#9EBF91" />
            </svg>
            <span className="text-[23px] text-[#000000] leading-[30px]">MENA</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoCoverage;
